/**
 * Check if the current hostname matches the prod domain
 * @returns {boolean}
 */
export const isProd = () => {
    // return window.location.hostname.includes("localhost");
    return window.location.hostname.includes("waynesandersonfarms.com");
};